import React from "react";
import { Link } from "react-router-dom";

/*
Reusable side nav link item. Not expandable, link to a page on click (no page reload is performed)
*/
const SideNavLink = ({ title, icon, link }) => {
  const { pathname } = window.location;
  const match = pathname.match(link);
  const active = match && match.index === 0;
  const liClass = "sidenav-item " + (active ? "active" : "");

  return (
    <li className={liClass} onClick={() => window.layoutHelpers.toggleCollapsed(true)}>
      <Link to={link} className="sidenav-link">
        {icon}
        <div>{title}</div>
      </Link>
    </li>
  );
};

export default SideNavLink;



// WEBPACK FOOTER //
// ./src/views/components/sidenav/sideNavLink.js